const styles = {
    container: {
        height: "100vh",
        display: "flex",
        flexDirection: "column"
    },
    topBar: {
        position: "sticky",
        top: 0,
        zIndex: 1000,
    },
    content: {
        flex: 1,
        overflow: "hidden",
        minHeight: 0,
        "& > *": { height: "100%" },
    }
};
export default styles;
